var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRibon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.149,
    height: 65.408,
    viewBox: "0 0 51.149 65.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4265038_badge_guarantee_quality_ribbon_warranty_icon",
    "data-name": "4265038_badge_guarantee_quality_ribbon_warranty_icon",
    transform: "translate(-13.951 0.016)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(29.023 14.855)",
    fill: "#efa462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M64.221,24.425a4.22,4.22,0,0,0-.863-5.993l-1.788-1.3a4.22,4.22,0,0,1-1.727-3.781l.189-2.2a4.22,4.22,0,0,0-3.965-4.6L53.859,6.43a4.22,4.22,0,0,1-3.495-2.248L49.343,2.225A4.22,4.22,0,0,0,43.523.539L41.6,1.627a4.22,4.22,0,0,1-4.159,0L35.522.539a4.22,4.22,0,0,0-5.814,1.707L28.686,4.2A4.22,4.22,0,0,1,25.191,6.45l-2.207.123a4.22,4.22,0,0,0-3.965,4.6l.189,2.2a4.22,4.22,0,0,1-1.727,3.781l-1.788,1.3a4.22,4.22,0,0,0-.863,5.993l1.349,1.747a4.22,4.22,0,0,1,.593,4.113l-.8,2.044a4.22,4.22,0,0,0,2.514,5.508l2.08.741a4.22,4.22,0,0,1,2.723,3.142l.4,1.942L18.375,60.936,26.8,58.3l5.242,7.092,4.787-15.65a4.22,4.22,0,0,0,5.145.189l5.038,15.461L52.25,58.3l8.42,2.636L55.234,44.259c.036-.118.066-.23.092-.353l.434-2.166A4.22,4.22,0,0,1,58.483,38.6l2.08-.741a4.22,4.22,0,0,0,2.514-5.508l-.8-2.044a4.22,4.22,0,0,1,.593-4.113Zm-39.286.93A14.587,14.587,0,1,1,39.523,39.942,14.587,14.587,0,0,1,24.935,25.355Z",
    transform: "translate(0 0)",
    fill: "#efa462"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibon);
export default __webpack_public_path__ + "static/media/ribon.54a12799558cf95fdc63a450364bf1be.svg";
export { ForwardRef as ReactComponent };